import { defaultHttpClient } from '../../httpClient';
import type { GetMumulLiveProfileStatusResponse } from './types';

/**
 * - 무물라이브 프로필 상태 조회 API
 */
export const getMumulLiveProfileStatus = (profileSno: number) => {
  return defaultHttpClient
    .request<GetMumulLiveProfileStatusResponse>({
      method: 'GET',
      url: `/webview/mumul-live/profiles/${profileSno}/status/`,
    })
    .then(r => r.data);
};
